/**
 * Application metadata used across the UI.
 */

const stage = "pre-alpha" as const;

const BANNERS: Record<string, string> = {
  "pre-alpha":
    "Pre-alpha. Test networks only: Bitcoin regtest, Ethereum Sepolia and the F1r3fly test shard. Do not send real funds.",
};

export const siteMetadata = {
  title: "SATCHEL",
  /** What the name stands for. */
  expansion: "Smart Asset Technology for Capital and Hyper-Efficient Liquidity",
  /** Version, release stage and build commit, as release artifacts are named. */
  versionLabel: `${__APP_VERSION__} ${stage} · ${__GIT_COMMIT__}`,
  releaseStatus: {
    stage,
    /** Shown on onboarding; empty once the app is released. */
    banner: BANNERS[stage] ?? "",
  },
  urls: {
    smartAssets: {
      marketplace: "https://www.smart-assets.io/app/marketplace",
    },
  },
  // Demo mode: demo contacts and testnet-only affordances. VITE_SATCHEL_DEMO_MODE
  // (PWA) or SATCHEL_DEMO_MODE (Electron) turns it on; dev builds have it on.
  demoMode: {
    enabled:
      import.meta.env.VITE_SATCHEL_DEMO_MODE === "true" ||
      (typeof process !== "undefined" && process.env?.SATCHEL_DEMO_MODE === "true") ||
      import.meta.env.DEV,
    showToggle: !import.meta.env.PROD,
  },
  // Prototype features (Smart Assets, Exchange, SA Credits) run on simulated
  // data and stay out of the app unless VITE_SATCHEL_PROTOTYPES=true.
  prototypes: {
    enabled: import.meta.env.VITE_SATCHEL_PROTOTYPES === "true",
  },
};
